export const emailTemplateRelatedItems = [
  {
    messageType: 'PRIVATE',
    merchantId: '0d18d2b3-7de0-4e16-b68e-f28a92bb8737',
    programId: 'c844d2ab-b583-4e98-b694-546b853c6ce4',
    campaignId: '0028e10a-a1c6-4e6b-ba9a-4e94b517475f',
    messageId: 'd688698c-b325-4e78-89f1-bfe537a629bf',
    title: 'Dushantha Test Message - 06',
    createdDate: '07/02/2024 05:01:02',
    updatedDate: '07/02/2024 05:01:02',
    noDistributed: 0,
    messageDisplayInfo: [
      {
        languageCode: 'EN',
        title: 'sdsd',
        shortDescription: 'sds',
        longDescription: 'ssd',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/MicrosoftTeams-image%20%286%29_2beff4fd9aa34dea9f366a0f191f41e5.png',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/MicrosoftTeams-image%20%286%29_fc002850a72841f7a5ecbda015bd1fc8.png',
      },
    ],
    activityNames: [],
    reach:
      '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;0d18d2b3-7de0-4e16-b68e-f28a92bb8737;*"]',
    templateId: '86a17fdb-2983-4e27-9daa-82f19100714a',
    deleted: false,
  },
];
